/**
 * Custom hook that queries for data with
 * Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import { graphql, useStaticQuery } from 'gatsby';

function useGraphQL() {
  const data = useStaticQuery(
    graphql`
      {
        site {
          siteMetadata {
            address
            author
            description
            email
            facebook
            hours
            instagram
            phone {
              name
              numberDisplay
              numberFormatted
            }
            siteUrl
            title
          }
        }
        heroImage: file(relativePath: { eq: "hero2.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 1920) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        shopLadiesImage: file(relativePath: { eq: "shop-ladies.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 640) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        shopMensImage: file(relativePath: { eq: "shop-mens.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 640) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        blogSidebarLadies: file(
          relativePath: { eq: "blog-sidebar-ladies.jpg" }
        ) {
          childImageSharp {
            fluid(maxWidth: 640) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        blogSidebarMens: file(relativePath: { eq: "blog-sidebar-mens.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 640) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        ogImage: file(relativePath: { eq: "og-image.jpg" }) {
          publicURL
        }
        placeholderImage: file(relativePath: { eq: "placeholder.jpg" }) {
          publicURL
          addToCartAlert: childImageSharp {
            fixed(width: 96) {
              src
            }
          }
        }
      }
    `
  );
  return data;
}

export { useGraphQL };
